import { ChainId, JSBI, Percent, Token } from '@pancakeswap/sdk'
import { chainTokens, mainnetTokens, ropstenTokens, testnetTokens, toToken, waspTokens } from './tokens'
import { ChainToken } from './types'

// export const ROUTER_ADDRESS = '0x10ED43C718714eb63d5aA57B78B54704E256024E'
// export const ROUTER_ADDRESS = process.env.REACT_APP_ROUTER_ADDRESS || '0x019bca9a32930E443A9220Aa16CeC7d34a374296'

export const TUSDT = new Token(ChainId.ROPSTEN, '0x1cf98d2a2f5b0BFc365EAb6Ae1913C275bE2618F', 18, 'USDT', 'Testnet USDT')
export const TUSDC = new Token(ChainId.ROPSTEN, '0x1F0D2251f51b88FaFc90f06F7022FF8d82154B1a', 18, 'USDC', 'Testnet USDC')
export const TDAI = new Token(ChainId.ROPSTEN, '0xC4401D8D5F05B958e6f1b884560F649CdDfD9615', 18, 'DAI', 'Testnet Ropsten DAI')


// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}



// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  [ChainId.BSCMAINNET]: [
    // mainnetTokens.wbnb,
    mainnetTokens.cake,
    mainnetTokens.busd,
    mainnetTokens.usdt,
    mainnetTokens.btcb,
    mainnetTokens.ust,
    mainnetTokens.eth,
    mainnetTokens.usdc,
  ],
  [ChainId.BSCTESTNET]: [testnetTokens.wbnb, testnetTokens.cake, testnetTokens.busd],
  [ChainId.ROPSTEN]: [ropstenTokens.weth, ropstenTokens.usdt, ropstenTokens.usdc, ropstenTokens.usdc],
  [ChainId.WASP_TEST]: [waspTokens.iota, waspTokens.usdt, waspTokens.usdc, waspTokens.usdc],
  [ChainId.FANTOM_TESTNET]: [
    toToken(ChainId.FANTOM_TESTNET, chainTokens.weth),
    toToken(ChainId.FANTOM_TESTNET, chainTokens.usdt),
    toToken(ChainId.FANTOM_TESTNET, chainTokens.usdc),
    toToken(ChainId.FANTOM_TESTNET, chainTokens.smr),
    toToken(ChainId.FANTOM_TESTNET, chainTokens.lum)
  ],
  [ChainId.GÖRLI] :[],
  [ChainId.KOVAN] : [],
  [ChainId.RINKEBY] : [],
  [ChainId.MAINNET] : [],
  [ChainId.POLYGON] : [],
  [ChainId.FANTOM] : [],
  [ChainId.SHIMMER] : [
    toToken(ChainId.SHIMMER, chainTokens.usdt),
    toToken(ChainId.SHIMMER, chainTokens.smr),
    toToken(ChainId.SHIMMER, chainTokens.lum),
    toToken(ChainId.SHIMMER, chainTokens.bolt)
  ],
  [ChainId.STARDUST_TEST] : [
    toToken(ChainId.STARDUST_TEST, chainTokens.weth),
    toToken(ChainId.STARDUST_TEST, chainTokens.usdt),
    toToken(ChainId.STARDUST_TEST, chainTokens.usdc),
    toToken(ChainId.STARDUST_TEST, chainTokens.smr),
    toToken(ChainId.STARDUST_TEST, chainTokens.lum)
  ],
  [ChainId.TRUST_EVM] : [],
  [ChainId.IOTA_EVM] : []
}

/**
 * Addittional bases for specific tokens
 * @example { [WBTC.address]: [renBTC], [renBTC.address]: [WBTC] }
 */
export const ADDITIONAL_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {},
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 * @example [AMPL.address]: [DAI, WETH[ChainId.MAINNET]]
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {},
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  [ChainId.BSCMAINNET]: [mainnetTokens.busd, mainnetTokens.cake, mainnetTokens.btcb],
  [ChainId.BSCTESTNET]: [testnetTokens.wbnb, testnetTokens.cake, testnetTokens.busd],
  [ChainId.GÖRLI] :[],
  [ChainId.KOVAN] : [],
  [ChainId.RINKEBY] : [],
  [ChainId.MAINNET] : [],
  [ChainId.ROPSTEN] : [ropstenTokens.iota, ropstenTokens.pearl, ropstenTokens.usdc],
  [ChainId.POLYGON] : [],
  [ChainId.FANTOM] : [],
  [ChainId.FANTOM_TESTNET] : [
    toToken(ChainId.FANTOM_TESTNET, chainTokens.smr),
    toToken(ChainId.FANTOM_TESTNET, chainTokens.lum),
    toToken(ChainId.FANTOM_TESTNET,  chainTokens.usdc)
  ],
  [ChainId.WASP_TEST] : [
    waspTokens.iota, waspTokens.pearl, waspTokens.usdc],
  [ChainId.SHIMMER] : [
      toToken(ChainId.SHIMMER, chainTokens.smr),
      toToken(ChainId.SHIMMER, chainTokens.lum),
      toToken(ChainId.SHIMMER, chainTokens.usdt),
      toToken(ChainId.SHIMMER, chainTokens.bolt)
  ],
  [ChainId.STARDUST_TEST] : [
    toToken(ChainId.STARDUST_TEST, chainTokens.smr),
    toToken(ChainId.STARDUST_TEST, chainTokens.lum),
    toToken(ChainId.STARDUST_TEST, chainTokens.usdc)
  ],
  [ChainId.TRUST_EVM] : [],
  [ChainId.IOTA_EVM] : []
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  [ChainId.BSCMAINNET]: [ /* mainnetTokens.wbnb, */ mainnetTokens.dai, mainnetTokens.busd, mainnetTokens.usdt],
  [ChainId.BSCTESTNET]: [testnetTokens.wbnb, testnetTokens.cake, testnetTokens.busd],
  [ChainId.GÖRLI] :[],
  [ChainId.KOVAN] : [],
  [ChainId.RINKEBY] : [],
  [ChainId.MAINNET] : [],
  [ChainId.POLYGON] : [],
  [ChainId.FANTOM] : [],
  [ChainId.ROPSTEN] : [ropstenTokens.iota, ropstenTokens.pearl, ropstenTokens.usdc, ropstenTokens.usdt],
  [ChainId.FANTOM_TESTNET] : [
    toToken(ChainId.FANTOM_TESTNET, chainTokens.smr),
    toToken(ChainId.FANTOM_TESTNET, chainTokens.lum),
    toToken(ChainId.FANTOM_TESTNET, chainTokens.usdc),
    toToken(ChainId.FANTOM_TESTNET, chainTokens.usdt)
  ],
  [ChainId.WASP_TEST] : [waspTokens.iota, waspTokens.pearl, waspTokens.usdc, waspTokens.usdt],
  [ChainId.SHIMMER] : [
    toToken(ChainId.SHIMMER, chainTokens.smr),
    toToken(ChainId.SHIMMER, chainTokens.lum),
    toToken(ChainId.SHIMMER, chainTokens.usdt),
    toToken(ChainId.SHIMMER, chainTokens.bolt)
  ],
  [ChainId.STARDUST_TEST] : [
    toToken(ChainId.STARDUST_TEST, chainTokens.smr),
    toToken(ChainId.STARDUST_TEST, chainTokens.lum),
    toToken(ChainId.STARDUST_TEST, chainTokens.usdc),
    toToken(ChainId.STARDUST_TEST, chainTokens.usdt)
  ],
  [ChainId.TRUST_EVM] : [],
  [ChainId.IOTA_EVM] : []
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {
  [ChainId.MAINNET]: [
    /* [mainnetTokens.cake, mainnetTokens.wbnb ], */
    [mainnetTokens.busd, mainnetTokens.usdt],
    [mainnetTokens.dai, mainnetTokens.usdt],
  ],
}

export const NATIVE_ASSET_LABEL = {
  [ChainId.FANTOM_TESTNET] : {
    symbol: "FTM",
    name: "Fantom",
    show: true
  },
  [ChainId.SHIMMER] : {
    symbol: "SMR",
    name: "Shimmer",
    show: false
  },
}


// pids for price pairs used in hook usePollCoreFarmData
export const BASE_PRICE_PAIR_FARM_PIDS : { readonly [key: number] : number[] } = {
  [ChainId.FANTOM_TESTNET] : [1, 3], // lum-smr, smr-usdc
  [ChainId.SHIMMER] : [1, 3] // lum-smr, smr-usdt
}

// pid for base pair e.g. smr-lum, ftm-xxx, used in usePriceCakeBusd
export const FARM_TOKEN_PRICE_PID : { readonly [key: number] : number } = {
  [ChainId.FANTOM_TESTNET] : 1, // smr-lum
  [ChainId.SHIMMER] : 1 // smr-lum
}

// pid for usd pair used in fetchFarmsPrices
export const FARM_USD_TOKEN_PRICE_PID : { readonly [key: number] : number } = {
  [ChainId.FANTOM_TESTNET] : 3, // smr-udsc
  [ChainId.SHIMMER] : 3 // smr-usdt
}

// symbol to check against in getFarmQuoteTokenPrice, getFarmBaseTokenPrice, token check in usdBUSDPrice
export const BASE_PRICE_TOKENS : { readonly [key: number] : { usdToken: Token, wrappedToken: Token} } = {
  [ChainId.FANTOM_TESTNET] : { usdToken: toToken(ChainId.FANTOM_TESTNET, chainTokens.usdc) ,
    wrappedToken: toToken(ChainId.FANTOM_TESTNET, chainTokens.smr) },
  [ChainId.SHIMMER] : { usdToken: toToken(ChainId.SHIMMER, chainTokens.usdt) ,
    wrappedToken: toToken(ChainId.SHIMMER, chainTokens.smr) }
}

export const NetworkContextName = 'NETWORK'

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

export const BIG_INT_ZERO = JSBI.BigInt(0)

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much BNB so they end up with <.01
export const MIN_BNB: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 BNB
export const BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(JSBI.BigInt(50), JSBI.BigInt(10000))

export const ZERO_PERCENT = new Percent('0')
export const ONE_HUNDRED_PERCENT = new Percent('1')

// SDN OFAC addresses
export const BLOCKED_ADDRESSES: string[] = [
 /* '0x7F367cC41522cE07553e823bf3be79A889DEbe1B',
  '0xd882cFc20F52f2599D84b8e8D58C7FB62cfE344b',
  '0x901bb9583b24D97e995513C6778dc6888AB6870e',
  '0xA7e5d5A720f06526557c513402f2e6B5fA20b008',
  '0x8576aCC5C05D6Ce88f4e49bf65BdF0C62F91353C', */
]

export { default as farmsConfig } from './farms'
export { default as poolsConfig } from './pools'
export { default as ifosConfig } from './ifo'
export { default as ifosConfig2 } from './ifo2'
export { default as boostersConfig } from './boosters'
export { default as zapInsConfig } from './zapIns'

export const FAST_INTERVAL = 10000
export const SLOW_INTERVAL = 60000

export const EXCHANGE_DOCS_URLS = 'https://docs.pancakeswap.finance/products/pancakeswap-exchange'


export const NOT_ON_SALE_SELLER = '0x0000000000000000000000000000000000000000'
